// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"72939ad4","787":"1341726a","797":"31f535b0","821":"a57c833c","931":"ac1b3cf3","967":"edd20665"}[chunkId] + ".chunk.js";
};